import React from 'react';
import styled from 'styled-components';
import {Link} from 'react-router-dom';

type Props = {
  to: string,
  active: boolean,
  children: React.ReactNode,
};

const TabItem = ({to, active, children}: Props) => (
  <li>
    <MenuLink to={to} active={active}>
      {children}
    </MenuLink>
  </li>
);

export {TabItem};

const MenuLink = styled(Link).attrs(props => ({
  to: props.to,
}))`
  color: ${props => (props.active === 'true' ? '#ef5350' : '')} !important;
  font-weight: ${props =>
    props.active === 'true' ? 'bold' : 'none'} !important;
  border-bottom: ${props =>
    props.active === 'true' ? '1px solid red' : ''} !important;
`;
